import { styled } from "styled-components";
import { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { API_BASE } from "../../shared/Constants";
import { copyToClipboard } from "../../utils/clipboard";


export default function Snippet() {
  const [copied, setCopied] = useState(false);

  const snippet = `curl "${API_BASE}/api/chat/completions" \\
    -H "Content-Type: application/json" \\
    -H "Authorization: Bearer <API_KEY>" \\
    -d '{
        "model": "sabia-4",
        "messages": [
            {
                "role": "user",
                "content": "Olá, Mundo!"
            }
        ]
    }'`;

  const handleCopy = async () => {
    const ok = await copyToClipboard(snippet);
    if (ok) setCopied(true);
  };

  useEffect(() => {
    if (!copied) return;
    const id = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(id);
  }, [copied]);

  return (
    <>
      <CodeContainer>
        <CopyButton onClick={handleCopy} aria-label="Copiar">
          {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
        </CopyButton>
        <CodeBlock>{snippet}</CodeBlock>
      </CodeContainer>
    </>
  );
}

const CodeContainer = styled.div`
  position: relative;
`;

const CodeBlock = styled.pre`
  background: ${(props) => props.theme.white_divider};
  color: ${(props) => props.theme.text_primary};
  border-radius: 8px;
  padding: 12px;
  font-family: "Source Code Pro", monospace;
  font-size: 0.9rem;
  user-select: all;
  overflow-x: auto;
`;

const CopyButton = styled(IconButton)`
  && {
    position: absolute;
    top: 20px;
    right: 5px;
    border-radius: 6px;
    padding: 4px;
  }
`;
